<template>
  <div
    v-if="props.author"
    class="author-card"
    :class="{'author-card--big': props.isBig}"
  >
    <NuxtLink
      :to="getAuthorDetailPath()"
    >
      <div class="badge__aside">
        <img
          loading="lazy"
          v-if="getAvatar() && !imageError"
          class="object-cover h-full w-full"
          :src="getAvatar()"
          :alt="props.author?.fullname || ''"
          width="60"
          height="60"
          @error="replaceByDefault"
        >
        <!--no profile-pic -->
        <DefaultIconsAccount v-if="!getAvatar() || imageError" />
        <!--no profile-pic -->
      </div>

      <div
        class="badge__body"
      >
        <div class="flex flex-col">
          <span class="badge__author-name break-words">
            {{ props.author?.fullname }}
          </span>
          <span class="badge__author-profession">
            {{ props.author?.profession }}
          </span>
        </div>
        <DefaultIconsArrowRight/>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import type {PropType} from "vue"
import {useAuthorUrl} from "~/composables/useAuthorUrl"
import type AuthorLocal from "~/libs/interfaces/AuthorLocal";

const props = defineProps({
  author: {type: Object as PropType<Partial<AuthorLocal>>, required: false},
  isBig: {type: Boolean, required: false, default: false},
  detailUrl: {type: String, required: false}
})

const localePath = useLocalePath()

const imageError = ref(false)

const getAvatar = () => {
  return props.author?.imageAsset?.urlWithProtocol || props.author?.avatarUrl
}

const replaceByDefault = () => {
  imageError.value = true
}

const getAuthorDetailPath = () => {
  if (props.detailUrl) {
    return props.detailUrl
  }
  return localePath({ name: 'authors-authorUrl', params: { authorUrl: useAuthorUrl(props.author?.id, props.author?.fullname || '') } })
}

</script>

<style lang="scss" scoped>

</style>
